import React, { Dispatch } from "react";
import { DiseaseCluster } from "fe-common/hooks/sortFeaturesWithCrs";
import { DDClinicalReasoning } from "fe-common/graphql/dao";
import { DescriptionAccordion } from "../common/DescriptionAccordion";
import { styled } from "@mui/material";
import { QualifiedFeature, UserRoles } from "fe-common/graphql";
import { RoleRestrictor } from "fe-web-components/roles/RoleRestrictor";
import { MiniDiseaseReasoning } from "./miniDiseaseReasoning";

//region [[ Styles ]]

const OverviewContainer = styled("div")(({ theme }) => ({
  padding: "10px",
}));

//endregion [[ Styles ]]

//region [[ Props ]]
export interface OverviewProps {
  fWithCrs: DiseaseCluster;
  selectedCR: DDClinicalReasoning;
  crs: DDClinicalReasoning[];
  onFindingSelect?: Dispatch<QualifiedFeature>;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const Overview = ({
  fWithCrs,
  selectedCR,
  crs,
  onFindingSelect,
}: OverviewProps) => {
  const fCrs = fWithCrs?.crs;
  const cr = selectedCR || fCrs[0];
  const description = cr?.disease[0]?.feature?.description?.text;

  if (!crs) return null;

  return (
    <OverviewContainer>
      <DescriptionAccordion description={description} onShowMore={() => {}} />
      <RoleRestrictor
        roles={[
          UserRoles.KahunBackofficeUsers,
          UserRoles.KahunPatientDemoUsers,
        ]}
      >
        <MiniDiseaseReasoning
          cr={cr}
          crs={crs}
          onFindingSelect={onFindingSelect}
        />
      </RoleRestrictor>
    </OverviewContainer>
  );
};

export default Overview;
